module.exports = __webpack_public_path__ + "static/img/icon_szh_wdfw_sjksh.7f417cec.png";